import gql from 'graphql-tag'

export const deleteContractFile = (contractId, fileUrl) => {
	return {
		mutation: gql`
			mutation ($contract_id: bigint!, $file_url: String!) {
				delete_contracts_files(
					where: {
						file_url: { _eq: $file_url }
						contract_id: { _eq: $contract_id }
					}
				) {
					affected_rows
				}
			}
		`,
		variables: {
			contract_id: contractId,
			file_url: fileUrl
		}
	}
}
